module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result29-abf106e372f15fe7fe8cc25c08b98c70.png";